import { jwtDecode } from "jwt-decode";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const PmStore = create(
	persist(
		(set, get) => ({
			isAuthenticated: false,
			selectedOrganization: null,
			token: null,
			knownOrganizations: [],
			claims: {},

			// Password setup prompt state (for new users after OTP verification)
			pendingPasswordSetup: false,
			pendingPasswordEmail: null,

			// setToken: (tok) => set((state) => ({ token: tok, isAuthenticated: true })),
			setToken: (newToken) => {
				set((state) => ({
					token: newToken,
					isAuthenticated: true,
					claims: (decodeJwt(newToken)).claims,
				}))
			},

			resetToken: () =>
				set((state) => ({
					token: null,
					isAuthenticated: false,
					claims: {},
					knownOrganizations: [],
					selectedOrganizationId: null,
					pendingPasswordSetup: false,
					pendingPasswordEmail: null,
				})),

			setSelectedOrg: (org) => {
				set((state) => ({
					selectedOrganization: org,
				}));

			},

			setKnownOrganizations: (orgs) =>
				set((state) => ({
					knownOrganizations: orgs,
				})),

			// Set pending password setup flag (called after new user OTP verification)
			setPendingPasswordSetup: (email) =>
				set((state) => ({
					pendingPasswordSetup: true,
					pendingPasswordEmail: email,
				})),

			// Clear pending password setup (called after user sets password or dismisses prompt)
			clearPendingPasswordSetup: () =>
				set((state) => ({
					pendingPasswordSetup: false,
					pendingPasswordEmail: null,
				})),
		}),
		{
			name: "pm-store", // name of the item in the storage (must be unique)
			storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
		}
	)
);


function decodeJwt(token) {
	const [h64, c64, signature] = token.split('.');
	const jwt = {
		header: (h64) ? JSON.parse(atob(h64)) : null,
		claims: (c64) ? JSON.parse(atob(c64)) : null,
		signature
	}
	console.log('jwt', jwt);
	return jwt;
}